/**
 * @prettier
 */
import { FormSelect } from '@pidedirecto/ui/form';
import { useLoadApi } from '@pidedirecto/ui/hooks';
import * as React from 'react';
import { findRestaurantServiceAreasApi } from 'src/api/letseatmanager/restaurantServiceArea/findRestaurantServiceAreasApi';
import { translate } from 'src/i18n/translate';
import { useSelector } from 'src/utils/react/useSelector';

export function FormRestaurantServiceAreaSelect({ name, label, placeholder, helperText, defaultValue, disabled, required, multiselectable }: Props): React.ReactElement {
    const restaurantId = useSelector((state) => state.app.restaurantId);

    const [loading, restaurantServiceAreas] = useLoadApi(findRestaurantServiceAreasApi, { restaurantId }, { requiredValues: [restaurantId], dependencies: [restaurantId], initialValue: [] });

    const options = required
        ? restaurantServiceAreas.map((restaurantServiceArea) => ({ label: restaurantServiceArea.name, value: restaurantServiceArea.restaurantServiceAreaId }))
        : [
              { label: '', value: null, content: <div style={{ height: 20 }}></div> },
              ...restaurantServiceAreas.map((restaurantServiceArea) => ({ label: restaurantServiceArea.name, value: restaurantServiceArea.restaurantServiceAreaId })),
          ];

    return (
        <FormSelect
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            defaultValue={defaultValue}
            options={options}
            disabled={disabled || loading}
            multiselectable={multiselectable}
            required={{
                value: !!required,
                message: translate('This field is required'),
            }}
        />
    );
}

type Props = {
    name: string;
    label?: string;
    placeholder?: string;
    helperText?: string;
    defaultValue?: string | null | undefined;
    disabled?: boolean;
    required?: boolean;
    multiselectable?: boolean;
};
